import React from 'react';
import { Card, Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faAngleUp, faDollarSign, faCheckCircle, faProjectDiagram } from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import './Metrics.css';

const colors = {
    darkBlue: '#11343A',
    darkGreen: '#115E42',
    lightGreen: '#6BA772'
};

interface Props {
    customers: number;
    growthPercentage: number;
    expenses?: number;
    projectsCompleted?: number;
}

interface MetricWidgetProps {
    icon: IconDefinition;
    title: string;
    value: number | string;
    growth?: number;
    color?: string;
}

const MetricWidget: React.FC<MetricWidgetProps> = ({ icon, title, value, growth, color = colors.darkBlue }) => {
    return (
        <div className="d-flex align-items-center mb-3">
            <div className="rounded-circle p-3 me-3 d-flex align-items-center justify-content-center" 
                 style={{ width: '50px', height: '50px', backgroundColor: color }}>
                <FontAwesomeIcon icon={icon} size="lg" className="text-white" />
            </div>

            <div>
                <div className="fs-6 fw-bold">{title}</div>
                <h4 className="mb-0">{value}</h4>
            </div>
            {growth !== undefined && (
                <div className="ms-auto" style={{ color: colors.lightGreen }}>
                    <FontAwesomeIcon icon={faAngleUp} /> {growth}%
                    <div className="text-muted small">Since last quarter</div>
                </div>
            )}
        </div>
    );
};

const Metrics: React.FC<Props> = ({ customers, growthPercentage, expenses, projectsCompleted }) => {
    return (
        <Container className="metrics">
            <Row className="justify-content-center">
                <Col>
                    <Card className="shadow-sm">
                        <Card.Body>
                            <h3 className="fs-5 fw-bold mb-4">Metrics</h3>

                            {/* Widget per i progetti */}   
                            <MetricWidget 
                                icon={faProjectDiagram}
                                title="Project"
                                value={customers}
                                growth={growthPercentage}
                                color={colors.darkBlue}
                            />

                            {/* Widget per le spese totali */}
                            {expenses !== undefined && (
                                <MetricWidget 
                                    icon={faDollarSign}
                                    title="Total expenses"
                                    value={`$${expenses.toLocaleString()}`}
                                    color={colors.darkGreen}
                                />
                            )}

                            {/* Widget per i progetti completati */}
                            {projectsCompleted !== undefined && (
                                <MetricWidget 
                                    icon={faCheckCircle}
                                    title="Projects completed"
                                    value={projectsCompleted}
                                    color={colors.lightGreen}
                                />
                            )}

                            <p className="text-muted small mt-3 mb-0">
                                <FontAwesomeIcon icon={faGlobe} className="me-1" /> Worldwide data: 2025
                            </p>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Metrics;
